module.exports = __webpack_public_path__ + "static/media/diagnosticos__estetoscopio.7a42ac56.svg";